import React from 'react';
import { CheckCircle2, ScanLine, Blocks, Shield, Globe, Lock } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../contexts/LanguageContext';

export const Features = () => {
  const { t } = useLanguage();
  
  const features = [
    {
      icon: ScanLine,
      title: t('features.cards.aiSwarm.title'),
      description: t('features.cards.aiSwarm.description')
    },
    {
      icon: Blocks,
      title: t('features.cards.blockchain.title'),
      description: t('features.cards.blockchain.description')
    },
    {
      icon: Lock,
      title: t('features.cards.apiAccess.title'),
      description: t('features.cards.apiAccess.description')
    },
    {
      icon: Shield,
      title: t('features.cards.zeroTrust.title'),
      description: t('features.cards.zeroTrust.description'),
    },
    {
      icon: Globe,
      title: t('features.cards.decentralized.title'),
      description: t('features.cards.decentralized.description'),
    },
    {
      icon: CheckCircle2,
      title: t('features.cards.learning.title'),
      description: t('features.cards.learning.description'),
    },
    {
      icon: ScanLine,
      title: t('features.cards.spectroscopy.title'),
      description: t('features.cards.spectroscopy.description'),
    },
  ];

  return (
    <section id="features" className="py-20 sm:py-32 relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-serif font-bold mb-6">
            {t('features.title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            {t('features.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="glass border-card-border hover-lift group"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="pt-6">
                  <div className="flex flex-col h-full">
                    <div className="mb-4">
                      <div className="inline-flex p-3 rounded-xl bg-gradient-primary/10 border border-primary/20 group-hover:glow-teal transition-all duration-300">
                        <Icon className="w-6 h-6 text-primary-glow" />
                      </div>
                    </div>
                    <h3 className="text-xl font-serif font-semibold mb-3 text-foreground">
                      {feature.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};